
class HXFormFieldManualSelector extends HXFormField {

    /** @private */
    searchTextLast = "";

    constructor(inputName,formName) {
        super(inputName,formName);
    }

    /**
     * Liefert den Text der gewaehlten Option
     * @returns {string}
     */
    getSelectedText() {
        return this.inputObj.options[this.inputObj.selectedIndex].text;
    }

    /**
     * Liefert den Value der gewaehlten Option - identisch zu .getValue()
     * @returns {string}
     */
    getSelectedValue() {
        return this.getValue();
    }

    /**
     * Liefert zurueck ob der Leereintrag "-" angezeigt wird
     * @returns {boolean}
     */
    getOptionEmptyDisplay() {
        return this.inputObj.getAttribute("data-hx-optionempty") === 'true';
    }

    /**
     * Liefert Text des Leereintrages, wenn dieser angezeigt wird
     * @returns {string}
     */
    getOptionEmptyText() {
        var text = null;
        if (this.getOptionEmptyDisplay()===true) {
            for (var i = 0; i < this.inputObj.length; ++i) {
                if (this.inputObj.options[i].value === "null") text = this.inputObj.options[i].text;  //bei Manualselector wird 'null' in Option Value eingetragen
            }
        }
        return text;
    }


    /**
     * Leereintrag "-" ein oder ausblenden
     * @param {boolean} show
     * @param {string} text
     */
    setOptionEmpty(show,text="-") {
        var nullOptionIndex = null;
        for (var i = 0; i < this.inputObj.length; ++i){
            if (this.inputObj.options[i].value === "null") nullOptionIndex = i; //bei Manualselector wird 'null' in Option Value eingetragen
        }

        if (nullOptionIndex===0 && show===false) {
            this.inputObj.remove(nullOptionIndex);
        } else if(nullOptionIndex===null && show===true) {
            this.inputObj.add(new Option(text,"null"),0); //bei Manualselector wird 'null' in Option Value eingetragen
        } else if (nullOptionIndex===0 && text!==null) {
            this.inputObj.options[nullOptionIndex].text = text;
        }
        this.inputObj.setAttribute("data-hx-optionempty",show);
    }

    /**
     * @param {boolean} optional
     */
    setOptional(optional) {
        super.setOptional(optional,'select');
    }

    /**
     * @returns {boolean}
     */
    validateInput(alertResult=true) {
        super._validateFieldInit();

        if (this.fieldExists()===true && this.getEditable() === true) {
            if (!this.getOptional() && this.getOptionEmptyDisplay() && this.inputObj.options.selectedIndex<=0) { //<=0 weil: wird mit setValue() auf einen nicht vorhandenen Wert gesetzt, so steht der Index auf -1
                this.validationMsg = hx.replace(this.formVars.dictOptionalMsg, "#name#", this.getLabel());
                this.validationPassed = false;
            }
            if (alertResult===true) super._validateFieldAlert();
        }
        return this.validationPassed;
    }

    /**
     * Sucht in SELECT-Box nach Suchstring
     * @returns {boolean}
     */
    doSearch() {
        //Wert des Suchfeldes holen
        var searchTextCurrent = document.getElementsByName("ss"+this.inputName)[0].value.toUpperCase();

        //Wenn Suchfeld leer - ersten Dropdownwert setzten
        if(searchTextCurrent === ""){
            this.inputObj.selectedIndex = 0;
            this.searchTextLast = "";
            return false;
        }

        //Aktuellen DropdownIndex
        var suchIndexStart = this.inputObj.selectedIndex;
        if(suchIndexStart < 0) suchIndexStart = 0;
        suchIndexStart++; //ab dem naechsten weitersuchen

        //Wurde Suchtext geaendert - dann von anfang an suchen
        if(this.searchTextLast !== searchTextCurrent) {
            this.searchTextLast = searchTextCurrent;
            suchIndexStart = 0;
        }

        //Alle Options ab pos durchgehen
        for(var n = suchIndexStart; n < this.inputObj.options.length; n++){
            if(this.inputObj.options[n].text.toUpperCase().indexOf(searchTextCurrent) >= 0){
                this.inputObj.selectedIndex = n;
                if(this.inputObj.onchange) this.inputObj.onchange(); //Event ausfuehren falls aktiv
                if(this.inputObj.onblur) this.inputObj.onblur(); //Event ausfuehren falls aktiv
                return false;
            }
        }

        //Nichts gefunden - Dropdown auf ersten Eintrag setzten
        if(suchIndexStart >= 0){
            this.inputObj.selectedIndex = 0;
        }
    }

    displayInit() {
    }


    /**
     * Suchfeld Events einhaengen
     */
    displayInitSearchfield() {
        //Suchfeld Tastendruck
        document.getElementsByName("ss"+this.inputName)[0].addEventListener("keyup", (event) => { //arrow function erlaubt, das this in der Funktion das Hauptobjekt ist.
            hx.eventCancelBubble(event);
            if (event.key === "Enter") this.doSearch();
        });

        //Suchfeld-Icon Klick
        document.getElementsByName("ssbtn"+this.inputName)[0].addEventListener("click", (event) => { //arrow function erlaubt, das this in der Funktion das Hauptobjekt ist.
            this.doSearch();
        });
    }

}